var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(-19 -180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M6.9,20.585,2,24.432V4.1A1.1,1.1,0,0,1,3.1,3H22.882a1.1,1.1,0,0,1,1.1,1.1V19.486a1.1,1.1,0,0,1-1.1,1.1Zm5-6.594v2.2h2.2v-2.2Zm0-6.594v5.5h2.2V7.4Z",
    transform: "translate(27.51 188.784)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 43,
    height: 43,
    transform: "translate(19 180)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningMessage);
export default __webpack_public_path__ + "static/media/warning-message.1fc199f0eb5cbd0bde13b9f7e3f26214.svg";
export { ForwardRef as ReactComponent };